export default __webpack_public_path__ + "static/media/au_prop.8aedd76c.jpg";